export const CONTACT = {
  phone: "0141 255 1459",
  phoneNote: "for families & bookings",
  hours: "Mon – Fri, 9am – 5pm",
  mobile: "07761 329702",
  mobileNote: "weekday evenings from 5:30pm · weekends 9am – 8pm · job seekers welcome",
  email: "hello@bsbservices.co.uk",
  address: "2/3, 2nd Floor, 48 West George Street, Glasgow, G2 1BP",
  company: "Brightside Befriending Services Ltd",
  areas: ["Glasgow & surrounding areas", "Ayr & South Ayrshire"],
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1764173039543-f9f197744e1b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxzZW5pb3IlMjB0ZWElMjBjb252ZXJzYXRpb24lMjBzbWlsZXxlbnwwfHx8fDE3ODg4NzA2OTd8MA&ixlib=rb-4.1.0&q=85",
  tea: "https://images.unsplash.com/photo-1751977979267-91d412aeeda2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxzZW5pb3IlMjB0ZWElMjBjb252ZXJzYXRpb24lMjBzbWlsZXxlbnwwfHx8fDE3ODg4NzA2OTd8MA&ixlib=rb-4.1.0&q=85",
  walk: "https://images.unsplash.com/photo-1559234938-b60fff04894d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MjJ8MHwxfHNlYXJjaHwxfHxlbGRlcmx5JTIwd2FsayUyMHBhcmslMjBzdW5zaGluZSUyMGNvbXBhbmlvbnxlbnwwfHx8fDE3ODg4NzA2OTd8MA&ixlib=rb-4.1.0&q=85",
  park: "https://images.unsplash.com/photo-1780618612353-bde66efafcc8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxlbGRlcmx5JTIwY29tcGFuaW9uc2hpcCUyMHdhbGslMjBnYXJkZW4lMjB0ZWElMjBjb252ZXJzYXRpb24lMjBnbGFzc2dvdyUyMHNjb3RsYW5kJTIwd2FybXxlbnwwfHx8fDE3ODg4NzA2OTd8MA&ixlib=rb-4.1.0&q=85",
  loch: "https://images.unsplash.com/photo-1574625449101-411a69f7edcc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxlbGRlcmx5JTIwY29tcGFuaW9uc2hpcCUyMHdhbGslMjBnYXJkZW4lMjB0ZWElMjBjb252ZXJzYXRpb24lMjBnbGFzc2dvdyUyMHNjb3RsYW5kJTIwd2FybXxlbnwwfHx8fDE3ODg4NzA2OTd8MA&ixlib=rb-4.1.0&q=85",
};

export const MARQUEE_ITEMS = [
  "A friendly face on your doorstep",
  "Every befriender PVG checked",
  "Glasgow & Ayr — and everywhere between",
  "No waiting lists, ever",
  "Tea, talk & time together",
  "Companionship that feels like family",
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Everyone deserves company",
    text: "Loneliness is not a small thing. Around one in three older people in Scotland say they feel lonely some or most of the time. We exist to change that — one visit, one conversation, one shared pot of tea at a time.",
  },
  {
    num: "02",
    title: "Time, not tasks",
    text: "We don't clock-watch. Our befrienders stay for a proper chat, a slow wander round the park or a second cuppa — because unhurried time is the whole point.",
  },
  {
    num: "03",
    title: "Local and personal",
    text: "Born in Glasgow, for Glasgow. We match every client with a befriender who shares their interests, stories and sense of humour — not just their postcode.",
  },
  {
    num: "04",
    title: "Peace of mind for families",
    text: "When family lives far away, knowing someone kind is popping in matters. After every visit we send a short update, so you're never left wondering.",
  },
];

export const HOME_SERVICES = [
  {
    icon: "Coffee",
    title: "Companionship visits",
    text: "Someone to talk to and spend proper time with — conversation, games, reminiscing over old photographs.",
  },
  {
    icon: "Trees",
    title: "Walks, shopping & cafés",
    text: "Gentle strolls, a hand with the weekly shop, or a favourite café for a slice of cake and a natter.",
  },
  {
    icon: "Stethoscope",
    title: "Appointment companions",
    text: "A friendly escort to GP, hospital or hairdresser appointments — there and back, never rushed.",
  },
  {
    icon: "Phone",
    title: "Telephone & video check-ins",
    text: "Regular friendly calls to brighten the week and make sure everything's just as it should be.",
  },
  {
    icon: "Sparkles",
    title: "Social outings & activities",
    text: "Galleries, garden centres, community groups — rediscovering the people and places that bring joy.",
  },
  {
    icon: "Heart",
    title: "Hospital settling-in",
    text: "Warm, practical support in the first weeks after a hospital stay, helping someone feel at home again.",
  },
  {
    icon: "ShoppingBag",
    title: "Light housekeeping & errands",
    text: "A tidy-up together, prescriptions collected, parcels posted — the little jobs are easier with two.",
  },
  {
    icon: "HeartPulse",
    title: "Wellbeing & independent living",
    text: "Friendly check-ins on how someone's really doing, with gentle help for post, paperwork and routines.",
  },
  {
    icon: "Building2",
    title: "Care home & hospital befriending",
    text: "Extra one-to-one company for care home residents, and warm support during and after hospital stays.",
  },
];

export const STEPS = [
  {
    num: "1",
    title: "Say hello",
    text: "Book a free, no-pressure consultation. We'll chat with you or your loved one about what's needed — over the phone or in person.",
  },
  {
    num: "2",
    title: "We find your match",
    text: "We pair you with a PVG-checked befriender based on interests, personality, routine and locality. Chemistry matters.",
  },
  {
    num: "3",
    title: "A relaxed first visit",
    text: "A gentle trial visit to make sure it feels right. Not the right fit? We'll happily introduce someone new.",
  },
  {
    num: "4",
    title: "A brighter routine",
    text: "Regular visits settle into a comfortable rhythm — and after each one, families get a short update for complete peace of mind.",
  },
];

export const PRICING = [
  {
    title: "Weekly Befriending Visit",
    description: "One hour of warm conversation, tea, board games or sharing stories.",
    features: ["1-hour in-home visit", "Conversation, games & reminiscing", "The same befriender each time", "Family update after every visit"],
    popular: false,
  },
  {
    title: "Extended Companion Visit",
    description: "Ample time for walks, café visits, shopping trips or light outings.",
    features: ["2 full hours together", "Shopping trips & café visits", "Gentle walks & outings", "Family update after every visit"],
    popular: true,
  },
  {
    title: "Companion for Appointments",
    description: "Escort and friendly company for GP, hospital or hair appointments.",
    features: ["Door-to-door escort", "Wait with you throughout", "Help remembering what was said", "Family notified on safe return"],
    popular: false,
  },
  {
    title: "Telephone Companionship",
    description: "Regular friendly phone or video check-ins, 2–3 times a week.",
    features: ["2–3 friendly calls a week", "20–30 minutes each time", "The same familiar voice", "Any concerns flagged to family"],
    popular: false,
  },
  {
    title: "Bi-Weekly Companionship Bundle",
    description: "Two one-hour visits a month, plus a weekly check-in call.",
    features: ["2× 1-hour visits per month", "Weekly check-in call included", "One simple monthly arrangement", "Pause or change anytime"],
    popular: false,
  },
  {
    title: "Weekly Companionship Bundle",
    description: "A dedicated weekly visit plus check-ins and family updates. Our most loved arrangement.",
    features: ["4× 1-hour visits per month", "Same-befriender guarantee", "Check-in calls between visits", "Monthly family summary"],
    popular: true,
  },
  {
    title: "Hospital Discharge Settling-In",
    description: "Three visits across the first two weeks at home after a hospital stay.",
    features: ["3 visits in the first 2 weeks", "Fridge stocked & home settled", "Prescription collection help", "Handover call with family"],
    popular: false,
  },
  {
    title: "Respite Support",
    description: "Trusted one-to-one company for your loved one while the family carer rests, shops or recharges.",
    features: ["3 hours of unrushed company", "At home or out and about", "Light tasks & mealtime company included", "The same befriender each session"],
    popular: false,
  },
  {
    title: "Respite Bundle",
    description: "Four 3-hour respite sessions a month for regular family carers — the same trusted befriender, at a saving.",
    features: ["4× 3-hour respite sessions", "The same befriender every time", "Priority booking for your slots", "Monthly family summary"],
    popular: false,
  },
];

export const WHY_BRIGHTSIDE = [
  { title: "No waiting lists", text: "Council and charity services are stretched thin. With Brightside, visits can usually begin within days of your consultation." },
  { title: "The same friendly face", text: "Continuity builds trust. Your befriender is your befriender — not a rotating cast of strangers." },
  { title: "Completely flexible", text: "Weekly, fortnightly, mornings, weekends — visits bend around real life, not the other way round. Pause anytime." },
  { title: "Families kept in the loop", text: "Short updates after every visit mean sons, daughters and grandchildren always know how things are." },
];

export const WHO_WE_HELP = [
  { icon: "Users", title: "Isolated or lonely seniors", text: "Older people who spend too many days without a proper conversation or a reason to leave the house." },
  { icon: "Heart", title: "Families seeking reassurance", text: "Sons, daughters and grandchildren living away, who want kind eyes and ears close to someone they love." },
  { icon: "Sunrise", title: "Life transitions", text: "Retirement, bereavement, a move to a new home, or coming back from hospital — moments when company matters most." },
  { icon: "HomeIcon", title: "Care home residents", text: "Residents who'd love extra one-to-one time, a change of scene, or a trip out beyond the home's routine." },
  { icon: "Activity", title: "Rebuilding confidence", text: "After an illness or a fall, gentle encouragement getting back out into the world, one short walk at a time." },
  { icon: "Coffee", title: "Family carers", text: "The husbands, wives and daughters who do the caring — and deserve a few hours off with complete peace of mind." },
];

export const MORE_SERVICES = [
  { icon: "Sparkles", title: "Light housekeeping", text: "A tidy-up together — dishes done, laundry on, beds made — with company while the little jobs get done." },
  { icon: "HeartPulse", title: "Wellbeing visits", text: "A friendly check-in on how someone's really doing — mood, appetite, sleep — with anything worrying flagged to family." },
  { icon: "HomeIcon", title: "Independent living support", text: "Gentle help with the routines that keep someone independent: post, paperwork, phone calls and reminders." },
  { icon: "Users", title: "Community access", text: "Clubs, church, classes and community centres — getting there, joining in, and enjoying it together." },
  { icon: "Palette", title: "Hobbies & interests", text: "Gardening, crafts, music, puzzles, family history — dusting off old passions or discovering new ones side by side." },
  { icon: "ShoppingBag", title: "Assistance with errands", text: "Prescriptions collected, parcels posted, the bits of shopping that are simply easier with two." },
  { icon: "Building2", title: "Care home befriending", text: "Regular one-to-one visits for care home residents who'd love extra company beyond busy staff time." },
  { icon: "HeartHandshake", title: "Assisted living befriending", text: "Warm one-to-one visits for people in assisted living and sheltered housing — extra company beyond what onsite teams can give." },
  { icon: "Stethoscope", title: "Hospital befriending support", text: "Company during hospital stays, a friendly face for the journey home, and support settling back in." },
  { icon: "Clock", title: "Respite support", text: "A few hours of trusted company so the person who does the caring can rest, shop or see friends." },
  { icon: "UtensilsCrossed", title: "Mealtime companionship", text: "Sharing lunch, dinner or a Sunday roast — because meals are always better with company." },
];

export const TESTIMONIALS = [
  {
    quote: "Dad talks about his Wednesday visits all week. It's given him back something to look forward to — and honestly, it's given us peace of mind we couldn't put a price on.",
    name: "Fiona M.",
    relation: "Daughter of a client",
    area: "Bearsden",
  },
  {
    quote: "I hadn't been to the Botanics in years. Now we go every month. It doesn't feel like a service at all — it feels like a friend coming round.",
    name: "James S.",
    relation: "Client, aged 82",
    area: "Shawlands",
  },
  {
    quote: "The settling-in visits after Mum's hospital stay made all the difference. Someone noticed the little things we simply couldn't from 400 miles away.",
    name: "Aisha R.",
    relation: "Daughter living abroad",
    area: "Newton Mearns",
  },
  {
    quote: "Professional, warm and utterly reliable. The families we've signposted here all say the same thing — it feels like family.",
    name: "Elaine T.",
    relation: "Community link worker",
    area: "Glasgow",
  },
  {
    quote: "My befriender and I both support the same team. We argue about football and play dominoes. Best money I spend all month.",
    name: "Robert D.",
    relation: "Client, aged 78",
    area: "Partick",
  },
  {
    quote: "From the first phone call it felt different — unhurried, kind, genuinely interested in who Mum is, not just what she needs.",
    name: "Catriona B.",
    relation: "Daughter of a client",
    area: "Milngavie",
  },
];

export const FAQS = [
  {
    category: "Safety & trust",
    items: [
      {
        q: "Are your befrienders vetted?",
        a: "Yes — every Brightside befriender is PVG (Protecting Vulnerable Groups) checked and carefully vetted before they ever meet a client. For us, that's non-negotiable.",
      },
      {
        q: "Is Brightside a care agency?",
        a: "No. We provide companionship and social support, not personal or nursing care such as washing, dressing or medication. Many families use us alongside formal care — we're the friendly hour, not the clinical one.",
      },
      {
        q: "What if my loved one doesn't click with their befriender?",
        a: "Just tell us. Matching is personal, and we'll introduce someone new — quickly, kindly and without any fuss or awkwardness.",
      },
    ],
  },
  {
    category: "Pricing & payment",
    items: [
      {
        q: "How much does it cost?",
        a: "It depends on where you are and which arrangement suits best — we'll give you a clear, exact price at your free consultation, before anything starts. No hidden costs, ever.",
      },
      {
        q: "How do we pay?",
        a: "We invoice monthly in arrears, so you only ever pay for visits that have actually happened. Payment is by bank transfer or card.",
      },
      {
        q: "Is there a contract or minimum term?",
        a: "No. Everything is rolling and flexible — pause or stop with a week's notice. We'd rather earn every visit than lock anyone in.",
      },
    ],
  },
  {
    category: "Visits & matching",
    items: [
      {
        q: "How are befrienders matched?",
        a: "We match on interests, personality, routine and locality — a keen gardener gets a gardener, a football fan gets someone who'll argue about the line-up. Then a relaxed trial visit makes sure it clicks.",
      },
      {
        q: "What's the minimum visit length?",
        a: "One hour. Anything shorter doesn't leave room for a proper chat — and unhurried time is the whole point.",
      },
      {
        q: "Do you offer evenings or weekends?",
        a: "Yes. Many clients love a Saturday café trip or a Sunday afternoon visit. We'll shape visits around the rhythm that suits your family.",
      },
    ],
  },
  {
    category: "Areas we cover",
    items: [
      {
        q: "Where do you operate?",
        a: "Glasgow city and every surrounding town — including East Renfrewshire (Newton Mearns, Giffnock, Clarkston) and East Dunbartonshire (Bearsden, Milngavie, Bishopbriggs) — plus Ayr, Prestwick, Troon and the South Ayrshire coast. Unsure? Just ask — if we can't help, we'll say so honestly.",
      },
    ],
  },
];

export const OPENINGS = [
  {
    title: "Companion Befriender",
    location: "Glasgow Southside",
    type: "Part-time · Flexible hours",
    blurb: "Visits, walks and café trips with older clients across Shawlands, Giffnock and the wider Southside.",
  },
  {
    title: "Companion Befriender",
    location: "East Dunbartonshire",
    type: "Part-time · Flexible hours",
    blurb: "Support clients in Bearsden, Milngavie and Bishopbriggs with company, outings and appointments.",
  },
  {
    title: "Companion Befriender",
    location: "Ayr & South Ayrshire",
    type: "Part-time · Flexible hours",
    blurb: "Help us launch in Ayrshire — visits, walks and café trips with older clients across Ayr, Prestwick and Troon.",
  },
  {
    title: "Companion Befriender",
    location: "Glasgow West End",
    type: "Part-time · Flexible hours",
    blurb: "Visits and outings with older clients across Hillhead, Partick, Hyndland and the wider West End.",
  },
  {
    title: "Companion Befriender",
    location: "Glasgow East End & North",
    type: "Part-time · Flexible hours",
    blurb: "Company, errands and appointment support for clients across Dennistoun, Springburn and the East End.",
  },
  {
    title: "Companion Befriender",
    location: "East Renfrewshire",
    type: "Part-time · Flexible hours",
    blurb: "Befriending visits and café trips across Newton Mearns, Giffnock, Clarkston and Barrhead.",
  },
  {
    title: "Weekend Companion",
    location: "Glasgow & surrounds",
    type: "Weekends · Flexible",
    blurb: "Saturday café trips, Sunday afternoon visits and occasional day outings for clients whose families work or live away.",
  },
];

export const prettySlot = (slot) => {
  if (!slot) return "";
  const [h, m] = slot.split(":").map(Number);
  const suffix = h >= 12 ? "PM" : "AM";
  const hour = h % 12 || 12;
  return `${hour}:${String(m).padStart(2, "0")} ${suffix}`;
};

export const REFERRAL_BENEFITS = [
  { title: "A trusted private option", text: "For clients who don't qualify for statutory services, or who face long waiting lists for charitable befriending." },
  { title: "Settling-in after discharge", text: "Our hospital discharge package supports a safe, warm return home in the crucial first fortnight." },
  { title: "Written updates you can use", text: "Concise visit notes for referrers and families — flagged concerns reach the right people quickly." },
  { title: "Fully vetted befrienders", text: "Every befriender is PVG checked and personally interviewed, across Glasgow, Ayr and the surrounding areas." },
];
